/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-24 18:22:25
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-24 18:45:07
 * @FilePath: /unifyxp-v2-store-portal/src/components/DragContainers/LeftGreenBlock/index.tsx
 */
import React from 'react';

import css from './css.less';

const LeftGreenBlock = (props) => {
  const { children, blockHeight, hide, containerStyle, ..._p } = props;
  return (
    <div className={css.container} style={containerStyle || {}} {..._p}>
      {!hide && (
        <div
          className={css.greenBlock}
          {...(blockHeight ? { style: { height: blockHeight } } : {})}
        />
      )}

      {children}
    </div>
  );
};
export default LeftGreenBlock;
